





















/* General */

/* Mixins */
import entityTypeMixin from '@/mixins/entity-type.mixin'

/* Components */

/* Helpers */
import AppSumoAssistant from '@/helpers/appsumo-assistant'
import TextAssistant from '@/helpers/text-assistant'

/* Data types */
import { EEntities } from '@/types'

/* API */

interface IEmptyInfo {
  key: string
  icon: string
  adminTitle: string
  normalTitle: string
  adminDesc: string
  normalDesc: string
}

export default entityTypeMixin.extend({
  name: 'DashboardEntitiesEmpty',

  data() {
    return {
      EEntities,
      AppSumoAssistant,
      TextAssistant,
      emptyInfos: [
        {
          key: EEntities.MAILBOXES,
          icon: 'mailbox',
          adminTitle: 'Create a new mailbox',
          normalTitle: 'You have no Mailboxes yet.',
          adminDesc: `Manage your customer support or external email feedback with <strong>Mailboxes</strong>. 
          <a href='https://www.donedone.com/help-docs/what-are-mailboxes' 
          class='just-a-link' target='_blank'>Learn More</a>.`,
          normalDesc: `<a href='https://www.donedone.com/help-docs/what-are-mailboxes' 
          class='just-a-link' target='_blank'>Mailboxes</a> let you manage your customer support or external email feedback.
          <strong>Contact your account owner to be added to a mailbox.</strong>`,
        },
        {
          key: EEntities.PROJECTS,
          icon: 'project',
          adminTitle: 'Create a new project',
          normalTitle: 'You have no Projects yet.',
          adminDesc: `Use <strong>Projects</strong> to manage all the tasks you need to finish projects strong.
          <a href='https://www.donedone.com/help-docs/what-are-projects' 
          class='just-a-link' target='_blank'>Learn More</a>.`,
          normalDesc: `<a href='https://www.donedone.com/help-docs/what-are-projects'
          class='just-a-link' target='_blank'>Projects</a> 
          let you manage all the tasks you need to finish projects strong. <strong>Contact your account owner to be 
          added to a project.</strong>`,
        },
      ] as IEmptyInfo[],
    }
  },

  computed: {
    suppressEntityCreationOnMobile(): boolean {
      return this.$permissions.isAdminOrOwner && this.$screen.isMobile(this.$mq)
    },
    emptyInfo(): IEmptyInfo | any {
      return this.emptyInfos.find(e => e.key === this.entityType)
    },
    title(): string {
      return this.$permissions.isAdminOrOwner
        ? this.emptyInfo.adminTitle
        : this.emptyInfo.normalTitle
    },
    description(): string {
      return this.$permissions.isAdminOrOwner
        ? this.emptyInfo.adminDesc
        : this.emptyInfo.normalDesc
    },
  },

  methods: {},
})
